export const organizationUsageLabelsV822 = {
  title: '组织用量日志',
  dedicated_customer: '专属客户',
  owner_description: '查看本组织所有成员在已授权 Provider 上的请求终态与用量。',
  member_description: '仅查看本人在本组织内的请求与客户收费。',
  root_description: '按组织查看请求终态；实际上游尝试与客户最终结果分开记录。',
  provider_description:
    '此页保留 Vertex / Google Provider 日志与成本事实；跨 Provider 的组织请求请查看组织用量日志。',
  provider: 'Provider',
  token: 'Token 名称 / ID',
  requested_model: '请求模型',
  actual_model: '实际模型',
  resolution: '有效分辨率',
  first_response: '首响应',
  organization: '组织',
  organization_snapshot: '组织名称快照',
  all_organizations: '全部组织',
  member: '成员',
  start_time: '开始时间',
  end_time: '结束时间',
  attempts: '实际上游尝试',
  attempt: '尝试序号',
  channel: '内部渠道',
  billing_unavailable: '收费事实暂不可用',
  root_required: '仅 Root 可查看内部组织详情。',
  model_title: '专属客户模型',
  model_description:
    '模型范围仍受组织、成员与 Token 权限交集限制，不额外限定 Provider。',
  dashboard_title: '专属客户概览',
  dashboard_description: '按组织权限展示所有已授权 Provider 的使用统计。',
};

export const organizationUsageTextV822 = (t, key) =>
  t('organization_usage_v822.' + key, {
    defaultValue: organizationUsageLabelsV822[key] || key,
  });

export const organizationUsageBaseV822 = (root) =>
  root
    ? '/api/organization_usage_v822/'
    : '/api/billing/organization/usage_v822/';

export const organizationTokenLabelV822 = (item) =>
  [item.token_name, item.token_id ? '#' + item.token_id : '']
    .filter(Boolean)
    .join(' / ') || '-';

export const organizationUsageQueryV822 = (query, filters, root) => {
  if (filters.provider_family)
    query.set('provider_family', filters.provider_family);
  if (root && filters.billing_account_id)
    query.set('billing_account_id', filters.billing_account_id);
  if (root && filters.organization)
    query.set('organization', filters.organization);
  ['start', 'end'].forEach((key) => {
    const value = new Date(filters[key + '_time']).getTime();
    if (Number.isFinite(value) && value > 0)
      query.set(key + '_timestamp', String(Math.floor(value / 1000)));
  });
  return query;
};

export const organizationDetailMetersV822 = (detail, root) => {
  if (!root) return detail.meters || [];
  return (
    (detail.attempts || []).find(
      (attempt) => attempt.attempt_no === detail.request?.final_attempt_no
    )?.meters || []
  );
};
